<template>
    <div class="calendar-header">
      <button class="back-button" @click="$emit('prev-month')"> <img :src="require('./icons/prev.svg')" :alt="$t('noahfit.header.prev_alt')" style="width: 18px; height: 18px; margin-right: 4px;" /> </button>
      <span class="month-label">{{ monthNames[month] }} <span style="color: #37502e; font-weight: 500;">{{ year }}</span></span>
      <button class="back-button" @click="$emit('next-month')"> <img :src="require('./icons/next.svg')" :alt="$t('noahfit.header.next_alt')" style="width: 18px; height: 18px; margin-right: 4px;" /> </button>
    </div>
  </template>
  
  <script>
  export default { 
    props: ['month', 'year', 'monthNames']
  };
 </script>
   

 <style scoped>
  .calendar-header{
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin: 1rem 0;
   }
   .month-label {
  font-size: 1rem;
  font-weight: 300;
  
}

.back-button  { 
    border: none;
    border-radius: 0;
    min-width: 8em;
    min-height: 3em;   
    background: linear-gradient(45deg, #050505, #080808, #050505);  
    transition: transform 0.2s; 
    font-weight: 300;
    transition: transform 0.2s ease, box-shadow 0.3s ease, color 0.2s ease;  
  }
  
  .back-button:hover {
    transform: scale(1.05); 
    color: white;
    box-shadow: 0 5px 12px rgba(0, 104, 42, 0.2); 
  }
 </style>